import Icon from '../components/Icon.vue'

Icon.register({
  poll: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM160 368C160 376.8 152.8 384 144 384H112C103.2 384 96 376.8 96 368V240C96 231.2 103.2 224 112 224H144C152.8 224 160 231.2 160 240V368zM256 368C256 376.8 248.8 384 240 384H208C199.2 384 192 376.8 192 368V144C192 135.2 199.2 128 208 128H240C248.8 128 256 135.2 256 144V368zM352 368C352 376.8 344.8 384 336 384H304C295.2 384 288 376.8 288 368V304C288 295.2 295.2 288 304 288H336C344.8 288 352 295.2 352 304V368z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/poll.js
// module id = BzLY
// module chunks = 144